/** Returns a Tailwind background-color class for the given log level (error, warning, info, debug). */
const levelIndicatorClass = (level: string) => {
	const key = level?.toLowerCase();
	switch (key) {
		case "error":
			return "bg-rose-500";
		case "warning":
			return "bg-amber-400";
		case "information":
		case "info":
			return "bg-sky-400";
		case "debug":
			return "bg-slate-400";
		default:
			return "bg-slate-300";
	}
};

/** Normalizes a log level string to title case (e.g. "error" becomes "Error"), defaulting to "Info". */
const levelLabel = (level?: string | null) => {
	if (!level) return "Info";
	const normalized = level.trim();
	return normalized.charAt(0).toUpperCase() + normalized.slice(1).toLowerCase();
};

const TAG_STYLES: Record<string, string> = {
	preview: "border-emerald-100 bg-emerald-50 text-emerald-700",
	production: "border-indigo-100 bg-indigo-50 text-indigo-700",
	languages: "border-sky-100 bg-sky-50 text-sky-700",
	git: "border-rose-100 bg-rose-50 text-rose-700",
	branch: "border-rose-100 bg-rose-50 text-rose-700",
	commit: "border-purple-100 bg-purple-50 text-purple-700",
	content: "border-amber-100 bg-amber-50 text-amber-700",
	storage: "border-amber-100 bg-amber-50 text-amber-700",
	migration: "border-fuchsia-100 bg-fuchsia-50 text-fuchsia-700",
	users: "border-slate-200 bg-slate-100 text-slate-700"
};

/** Returns Tailwind border/background/text classes for a log tag (e.g. "preview", "production", "git"). */
const logTagStyle = (tag?: string | null) => {
	if (!tag) {
		return "border border-slate-200 bg-slate-100 text-slate-600";
	}
	const key = tag.trim().toLowerCase();
	return TAG_STYLES[key] ?? "border border-slate-200 bg-slate-100 text-slate-600";
};

export { levelIndicatorClass, levelLabel, logTagStyle };

